module.exports = __webpack_public_path__ + "static/media/bottom_banner_8_1.8e9ede9d.png";